import React from 'react'

function Mobile({ selected = false }) {
    return (
        <svg data-name="Group 6" xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" style={{pointerEvents:"none"}}>
        <g data-name="Rectangle Copy 66" fill="#fff" stroke="#202020" strokeMiterlimit="10" strokeWidth="1">
          <rect width="10" height="16" rx="2" stroke={selected ? "#0072c6" : "#606060"} />
          <rect x="0.5" y="0.5" width="9" height="15" rx="1.5" fill="none" stroke={selected ? "#0072c6" : "#606060"} />
        </g>
        <path data-name="Line 3" d="M.5.5h8" transform="translate(1 12)" fill="none" stroke={selected ? "#0072c6" : "#606060"} strokeLinecap="square" strokeMiterlimit="10" strokeWidth="1"/>
        <rect width="1" height="1" rx="0.5" transform="translate(4.5 13.5)" stroke={selected ? "#0072c6" : "#606060"} />
      </svg>
      
    )
}

export default Mobile
